import React from 'react';

class Loading extends React.Component {
   render() {
      return (
        <div className="app-content-loading">
            <img id="loadingImg" height="80px" className="loading-spinner" src="/img/loading.gif" alt="Loading..." />
        </div>
      );
   }
}

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/Loading.js
 **/